import interact from "./interact.vue"

const Interact = {
  install(Vue) {
    Vue.component("interact", interact)

    Vue.prototype.$interact = {
      alert: async (title, detail, position = "left") => {
        return this._init(title, detail, null, { position: position }, "alert")
      },
      confirm: async (title, detail, position = "left", confirm = null, cancel = null) => {
        return this._init(title, detail, [confirm, cancel], { position: position }, "confirm")
      },
      prompt: async (title, detail, position, data) => {
        if (!Array.isArray(data) || typeof data[0] !== "object") return false
        return this._init(title, detail, data, { position: position }, "prompt")
      }
    }
  },

  async _init(title, detail, data, options, type) {
    try {
      const $options = {
        position: "left"
      }

      if (["left", "right"].indexOf(options) > -1) $options.position = options
      if (typeof options === "object") Object.assign($options, options)
      if (!options.position) options.position = "left"

      const promise = await _$.progress.create()

      const $package = {
        title: title,
        detail: detail,
        data: data,
        options: $options,
        type: type,
        resolve: e => {
          promise.resolve(e)
        },
        reject: e => {
          promise.reject(e)
        }
      }

      _$.vue.$emit("interact", $package)

      return promise.done
    } catch (err) {
      return _$.error(err)
    }
  }
}

export default Interact
